import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import ModalHeader from '../../Setup/Shared/ModalHeader';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import DatePicker from '../../General/DatePicker';
import CustomTimePicker from '../../shared/CustomTimePicker/CustomTimePicker';
import handleNumericCheck from '../../../utils/HandleNumericKeys';
import { isBefore, parse, addMinutes, format, isDate, isAfter } from 'date-fns';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import { checkTimeFormat, convertTo12Hour, DateComparison, isValidMMDDYYYY } from '../../../utils/Constants';
import Loader from '../../shared/Loader/Loader';
import SuperSearchList from '../../shared/SuperSearch/SuperSearchList';
import isNull from '../../../utils/NullChecking';
import FormValidator from '../../../utils/FormValidator';
import NotificationHandler from '../../../utils/NotificationHandler';
import WeeklySubmission from '../../Reports/GeneralReports/WeeklySubmission';
import AvailableSlotsDropdown from '../AvailableSlotsDropDown/AvailableSlotsDropdown';
import DateValidator from '../../../utils/DateValidator';
import DataTable from '../DataTable/DataTable';


const RecurringPopup = (props) => {

    const { openPopup, onClose, onCloseSave, ID, mainApptModal, saveApptModal, ProID, LocID } = { ...props }
    console.log('mainAppointmentModal', mainApptModal.DurationID);

    let API_URL = enumUtil.controller.PATIENT;
    const API_URL_General = enumUtil.controller.General;
    let providerID = ProID ? ProID : "";
    let locationID = LocID ? LocID : "";
    let ApptDate = mainApptModal?.AppointmentDate ? mainApptModal?.AppointmentDate : null;
    let ApptDuration = mainApptModal?.DurationID ? mainApptModal?.DurationID : "";
    let ApptTime = mainApptModal?.AppointmentStart ? convertTo12Hour(mainApptModal?.AppointmentStart) : "";


    let DurationDD = [
        { value: '15', display: '15' },
        { value: '30', display: '30' },
        { value: '60', display: '60' },
    ]

    let Recurring_Daily_Modal = {
        "PERAM": "Day",
        "ProviderID": providerID,
        "LocationID": locationID,
        "RepeatAfter": "",
        "AppointmentDate": ApptDate,
        "EndOn": null,
        "PreferredTime": ApptTime,
        "DurationID": ApptDuration,
    }

    let Recurring_Weekly_Modal = {
        "PERAM": "Week",
        "ProviderID": providerID,
        "LocationID": locationID,
        "RepeatAfter": "",
        "AppointmentDate": ApptDate,
        "EndOn": null,
        "PreferredTime": ApptTime,
        "DurationID": ApptDuration,
        "OnDays": ""
    }

    let Days_Modal = {

        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,

    }

    let Appt_Date_Modal = {
        "AppointmentDate": ApptDate,
    }

    let ValidationModal = {
        "RepeatAfter": "",
        "EndOn": "",
        "AppointmentDate": "",
        "PreferredTime": "",
        "DurationID": "",
    }
    let dailyValModal = {}
    let weeklyValModal = {}

    let validationModalDate = {
        ApptDateVal: "",
        EndDateVal: "",
    }
    let validationModalDateDaily = {}
    let validationModalDateWeekly = {}
    const [DailyDateError, setDailyDateError] = useState(validationModalDate);
    const [WeeklyDateError, setWeeklyDateError] = useState(validationModalDate);
    const [DailyAppoitmentDateModal, setDailyAppointmentDateModal] = useState(Appt_Date_Modal);
    const [WeeklyAppoitmentDateModal, setWeeklyAppointmentDateModal] = useState(Appt_Date_Modal);

    const [mainRecurringDailyModal, setMainRecurringDailyModal] = useState(Recurring_Daily_Modal);
    const [saveRecurringDailyModal, setSaveRecurringDailyModal] = useState({
        "PERAM": "Day",
        "ProviderID": providerID + "",
        "LocationID": locationID + "",
        "AppointmentDate": ApptDate + "",
        "PreferredTime": ApptTime + "",
        "DurationID": ApptDuration + "",
    });

    const [mainRecurringWeeklyModal, setMainRecurringWeeklyModal] = useState(Recurring_Weekly_Modal);
    const [saveRecurringWeeklyModal, setSaveRecurringWeeklyModal] = useState(
        {
            "PERAM": "Week",
            "ProviderID": providerID + "",
            "LocationID": locationID + "",
            "AppointmentDate": ApptDate + "",
            "PreferredTime": ApptTime + "",
            "DurationID": ApptDuration + "",
            "OnDays": ""
        }
    );

    const [SavedData, setSavedData] = useState([])
    const [dailyValidationModal, setDailyValidationModal] = useState(ValidationModal);
    const [weeklyValidationModal, setWeeklyValidationModal] = useState(ValidationModal);

    const [activeKey, setActiveKey] = useState('Day');
    const [reloadPreferredTime, setReloadPreferredTime] = useState(false);

    const [DailyData, setDailyData] = useState([]);
    const [previousDailyData, setPreviousDailyData] = useState([]);

    const [WeeklyData, setWeeklyData] = useState([]);
    const [previousWeeklyData, setPreviousWeeklyData] = useState([]);

    const [DaysOnObject, setDaysOnObject] = useState(Days_Modal);
    const [selectedDay, setSelectedDays] = useState([]);

    const [availableSlots, setAvailableSlots] = useState([]);
    const [DailyAvailableStartTimeSlots, setDailyAvailableStartTimeSlots] = useState([]);
    const [WeeklyAvailableStartTimeSlots, setWeeklyAvailableStartTimeSlots] = useState([]);
    const [IsSlotAvailable, setIsSlotAvailable] = useState(false);

    const [weeklyIndexBasedRecord, setWeeklyIndexBasedRecord] = useState({});
    const [dailyIndexBasedRecord, setDailyIndexBasedRecord] = useState({});

    const [isDataSavedModal, setIsDataSavedModal] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const handleIndexBaseObject = (dataArray, modal, setModal) => {
        let obj = {}
        dataArray.map((item, index) => {
            // if (item.Status === 'Unavailable') {
            if (!obj[index]) {
                obj[index] = {
                    isEditable: false,
                    AvailableSlots: [],
                    ProvSchedule: '30',
                    DurationDD: [],
                }
            }
            // }
        })

        setModal(obj);
    }

    const handleDaysChange = (e, day) => {
        const { name, value, checked } = e.target
        let arr = [...selectedDay]
        let modal = { ...DaysOnObject }
        modal[day] = checked

        if (checked) {
            arr.push(day);
        } else {
            arr = arr.filter((item) => item !== day);
        }
        setSelectedDays(arr);
        setDaysOnObject(modal);

    }

    const HandleOnChangeDaily = (e) => {
        const { name, value, checked } = e.target
        const modal = { ...mainRecurringDailyModal }
        const saveModal = { ...saveRecurringDailyModal }

        modal[name] = value

        for (let property in Recurring_Daily_Modal) {
            if (property === name) {
                saveModal[name] = value
            }
        }

        setMainRecurringDailyModal(modal);
        setSaveRecurringDailyModal(saveModal);
    }
    //////////////// Daily Slot change ///////////////
    const handleOnChangeDailyStartTime = (e, name, value) => {

        const modal = { ...mainRecurringDailyModal }
        const saveModal = { ...saveRecurringDailyModal }
        let startTime;


        modal[name] = value == '-1' ? "" : value;
        saveModal[name] = value + "";
        setMainRecurringDailyModal(modal);
        setSaveRecurringDailyModal(saveModal);
        // closeDropdown();

    }

    //////////////// Daily Slot change ///////////////
    const handleOnChangeDailyIndexStartTime = (e, name, value, index, duration) => {

        const modal = [...DailyData]

        let startTime;

        // startTime = value;
        // if (!isNull(mainRecurringDailyModal.DurationID)) {
        //     const endTimes = timeParser(startTime ? startTime : mainRecurringDailyModal.AppointmentStart, mainAppointmentModal.DurationID);

        //     modal["AppointmentEnd"] = endTimes;
        //     saveModal["AppointmentEnd"] = endTimes;
        //     handleTimeSlots(saveModal, value);
        // }

        const itemFromModal = modal[index];
        itemFromModal[name] = value;
        itemFromModal['TimeTo'] = timeParser(value, duration);

        setDailyData(modal);
        // closeDropdown();

    }
    //////////////// Weekly Slot change ///////////////
    const handleOnChangeWeeklyStartTime = (e, name, value) => {

        const modal = { ...mainRecurringWeeklyModal }
        const saveModal = { ...saveRecurringWeeklyModal }
        let startTime;

        // startTime = value;
        // if (!isNull(mainRecurringDailyModal.DurationID)) {
        //     const endTimes = timeParser(startTime ? startTime : mainRecurringDailyModal.AppointmentStart, mainAppointmentModal.DurationID);

        //     modal["AppointmentEnd"] = endTimes;
        //     saveModal["AppointmentEnd"] = endTimes;
        //     handleTimeSlots(saveModal, value);
        // }

        modal[name] = value == '-1' ? "" : value;
        saveModal[name] = value + "";
        setMainRecurringWeeklyModal(modal);
        setSaveRecurringWeeklyModal(saveModal);
        // closeDropdown();

    }

    //////////////// Weekly Slot change ///////////////

    const handleOnChangeWeeklyIndexStartTime = (e, name, value, index, duration) => {

        const modal = [...WeeklyData]

        let startTime;

        // startTime = value;
        // if (!isNull(mainRecurringDailyModal.DurationID)) {
        //     const endTimes = timeParser(startTime ? startTime : mainRecurringDailyModal.AppointmentStart, mainAppointmentModal.DurationID);

        //     modal["AppointmentEnd"] = endTimes;
        //     saveModal["AppointmentEnd"] = endTimes;
        //     handleTimeSlots(saveModal, value);
        // }

        const itemFromModal = modal[index];
        itemFromModal[name] = value;
        itemFromModal['TimeTo'] = timeParser(value, duration)

        setWeeklyData(modal);
        // closeDropdown();

    }

    const HandleOnChangeDailyIndex = (e, index) => {
        const { name, value, checked } = e.target;
        const modal = [...DailyData];
        const itemFromModal = modal[index];
        itemFromModal[name] = value;

        setDailyData(modal);
    }

    const HandleOnChangeWeekly = (e) => {
        const { name, value, checked } = e.target
        const modal = { ...mainRecurringWeeklyModal }
        const saveModal = { ...saveRecurringWeeklyModal }

        modal[name] = value

        for (let property in Recurring_Weekly_Modal) {
            if (property === name) {
                saveModal[name] = value
            }
        }

        setMainRecurringWeeklyModal(modal);
        setSaveRecurringWeeklyModal(saveModal);
    }

    const HandleOnChangeWeeklyIndex = (e, index) => {
        const { name, value, checked } = e.target;
        const modal = [...WeeklyData];
        const itemFromModal = modal[index];
        itemFromModal[name] = value
        // const saveModal = { ...saveRecurringWeeklyModal }

        setWeeklyData(modal);
    }

    const handleCalendarChangeDaily = (date, type) => {

        const formatDate = date;
        // true if date1 < date2
        const StartDate = DailyAppoitmentDateModal?.AppointmentDate
        // if (isValidMMDDYYYY(StartDate)) {

        //     let isAfterDate = DateComparison(StartDate, formatDate);

        //     if (isAfterDate) {
        //         setMainRecurringDailyModal({ ...mainRecurringDailyModal, EndOn: formatDate });
        //         setSaveRecurringDailyModal({ ...saveRecurringDailyModal, EndOn: formatDate });

        //     } else {
        //         setMainRecurringDailyModal({ ...mainRecurringDailyModal, EndOn: formatDate });
        //         setSaveRecurringDailyModal({ ...saveRecurringDailyModal, EndOn: formatDate });
        //         NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
        //     }

        // } else {
        //     setMainRecurringDailyModal({ ...mainRecurringDailyModal, EndOn: formatDate });
        //     setSaveRecurringDailyModal({ ...saveRecurringDailyModal, EndOn: formatDate });
        // }
        if (isValidMMDDYYYY(StartDate)) {

            let isAfterDate = DateComparison(StartDate, formatDate);

            if (!isAfterDate) {
                NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
            }

        }
        setMainRecurringDailyModal({ ...mainRecurringDailyModal, EndOn: formatDate });
        setSaveRecurringDailyModal({ ...saveRecurringDailyModal, EndOn: formatDate });


        // getAvailableSlots(formatDate, 'Daily'); ye end on date he ispe ni chale gi ye appointment date pe chale gi 
    }

    const handleCalendarChangeAppointmentDaily = (date, type) => {

        const formatDate = date;
        const EndDate = mainRecurringDailyModal?.EndOn
        // if (isValidMMDDYYYY(EndDate)) {

        //     let isBeforeDate = DateComparison(formatDate, EndDate); // true if date1 < date2

        //     if (isBeforeDate) {
        //         setDailyAppointmentDateModal({ AppointmentDate: formatDate });
        //         setMainRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //         setSaveRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //         getAvailableSlots(formatDate, "Daily");
        //     } else {
        //         setDailyAppointmentDateModal({ AppointmentDate: formatDate });
        //         NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
        //     }

        // } else {
        //     setDailyAppointmentDateModal({ AppointmentDate: formatDate });
        //     setMainRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //     setSaveRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //     getAvailableSlots(formatDate, "Daily");
        // }
        if (isValidMMDDYYYY(EndDate)) {

            let isBeforeDate = DateComparison(formatDate, EndDate); // true if date1 < date2

            if (isBeforeDate) {
                getAvailableSlots(formatDate, "Daily");
            } else {
                NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
            }

        } else {
            getAvailableSlots(formatDate, "Daily");
        }
        setDailyAppointmentDateModal({ AppointmentDate: formatDate });
        setMainRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));
        setSaveRecurringDailyModal((prev) => ({ ...prev, PreferredTime: "" }));



        // getAvailableSlots(formatDate, 'Daily'); ye end on date he ispe ni chale gi ye appointment date pe chale gi 
    }

    const handleCalendarChangeDailyIndex = (date, type, index) => {
        let modal = [...DailyData]
        let itemFromModal = modal[index];

        const formatDate = date;

        itemFromModal['AppointmentDate'] = formatDate;
        itemFromModal['TimeFrom'] = "";
        setDailyData(modal);
        getAvailableSlotsIndex(formatDate, index, 'Daily');
        getProviderScheduler(formatDate, "Daily", index);
    }

    const handleCalendarChangeWeekly = (date, type) => {

        const formatDate = date;

        const StartDate = WeeklyAppoitmentDateModal?.AppointmentDate
        // if (isValidMMDDYYYY(StartDate)) {

        //     let isAfterDate = DateComparison(StartDate, formatDate);
        //     if (isAfterDate) {
        //         setMainRecurringWeeklyModal({ ...mainRecurringWeeklyModal, EndOn: formatDate });
        //         setSaveRecurringWeeklyModal({ ...saveRecurringWeeklyModal, EndOn: formatDate });
        //     } else {
        //           setMainRecurringDailyModal({ ...mainRecurringDailyModal, EndOn: formatDate });
        //         setSaveRecurringDailyModal({ ...saveRecurringDailyModal, EndOn: formatDate });
        //         NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
        //     }

        // } else {
        //     setMainRecurringWeeklyModal({ ...mainRecurringWeeklyModal, EndOn: formatDate });
        //     setSaveRecurringWeeklyModal({ ...saveRecurringWeeklyModal, EndOn: formatDate });
        // }
        if (isValidMMDDYYYY(StartDate)) {

            let isAfterDate = DateComparison(StartDate, formatDate);
            if (!isAfterDate) {
                NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
            }

        }
        setMainRecurringWeeklyModal({ ...mainRecurringWeeklyModal, EndOn: formatDate });
        setSaveRecurringWeeklyModal({ ...saveRecurringWeeklyModal, EndOn: formatDate });

        // getAvailableSlots(formatDate, 'Weekly');
    }

    const handleCalendarChangeAppointmentWeekly = (date, type) => {

        const formatDate = date;
        const EndDate = mainRecurringWeeklyModal?.EndOn
        // if (isValidMMDDYYYY(EndDate)) {

        //     let isBeforeDate = DateComparison(formatDate, EndDate); // true if date1 < date2
        //     if (isBeforeDate) {
        //         setWeeklyAppointmentDateModal({ AppointmentDate: formatDate });
        //         setMainRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //         setSaveRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //         getAvailableSlots(formatDate, "Weekly");
        //     } else {
        //         setWeeklyAppointmentDateModal({ AppointmentDate: formatDate });
        //         NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
        //     }

        // } else {
        //     setWeeklyAppointmentDateModal({ AppointmentDate: formatDate });
        //     setMainRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //     setSaveRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));
        //     getAvailableSlots(formatDate, "Weekly");
        // }
        if (isValidMMDDYYYY(EndDate)) {

            let isBeforeDate = DateComparison(formatDate, EndDate); // true if date1 < date2
            if (isBeforeDate) {
                getAvailableSlots(formatDate, "Weekly");
            } else {
                NotificationHandler('Please Select a valid date', enumUtil.enumtoaster.warning);
            }

        } else {
            getAvailableSlots(formatDate, "Weekly");
        }
        setWeeklyAppointmentDateModal({ AppointmentDate: formatDate });
        setMainRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));
        setSaveRecurringWeeklyModal((prev) => ({ ...prev, PreferredTime: "" }));


        // getAvailableSlots(formatDate, 'Daily'); ye end on date he ispe ni chale gi ye appointment date pe chale gi 
    }
    const handleCalendarChangeWeeklyIndex = (date, type, index) => {
        let modal = [...WeeklyData]
        let itemFromModal = modal[index];

        const formatDate = date;

        itemFromModal['AppointmentDate'] = formatDate;
        itemFromModal['TimeFrom'] = "";
        setWeeklyData(modal);
        getAvailableSlotsIndex(formatDate, index, 'Weekly');
        getProviderScheduler(formatDate, "Weekly", index);

    }
    ////////////////// handleAppointmentSelectedData /////////////

    const handleDailySelectedData = (selectedData, name, type) => {
        const modal = { ...mainRecurringDailyModal }
        const saveModal = { ...saveRecurringDailyModal }

        if (!isNull(selectedData)) {
            modal[name] = selectedData?.display;
            saveModal[name] = selectedData?.value;
        }
        setMainRecurringDailyModal(modal);
        setSaveRecurringDailyModal(saveModal);

    }

    const handleDailySelectedDataIndex = (selectedData, name, undefined1, undefined2, undefined3, index, StartTime) => {
        let modal = [...DailyData]
        let itemFromModal = modal[index];

        if (!isNull(selectedData)) {
            itemFromModal[name] = selectedData?.value;
            itemFromModal['TimeTo'] = !isNull(StartTime) ? timeParser(StartTime, selectedData?.value) : "";


        }
        setDailyData(modal);

    }

    const handleWeeklySelectedData = (selectedData, name, type) => {
        const modal = { ...mainRecurringWeeklyModal }
        const saveModal = { ...saveRecurringWeeklyModal }

        if (!isNull(selectedData)) {
            modal[name] = selectedData?.display;
            saveModal[name] = selectedData?.value;
        }

        setMainRecurringWeeklyModal(modal);
        setSaveRecurringWeeklyModal(saveModal);
    }

    const handleWeeklySelectedDataIndex = (selectedData, name, undefined1, undefined2, undefined3, index, StartTime) => {
        let modal = [...WeeklyData]
        let itemFromModal = modal[index];

        if (!isNull(selectedData)) {

            itemFromModal[name] = selectedData?.value;
            itemFromModal['TimeTo'] = !isNull(StartTime) ? timeParser(StartTime, selectedData?.value) : "";

        }
        setWeeklyData(modal);
    }

    const weeklyFormValidation = () => {
        let validationModal = {
            "RepeatAfter": FormValidator(mainRecurringWeeklyModal?.RepeatAfter, enumUtil.enumValidationType.Required, 'Repeats Every'),
            "EndOn": FormValidator(mainRecurringWeeklyModal?.EndOn, enumUtil.enumValidationType.Required, 'Ends on'),
            "AppointmentDate": FormValidator(WeeklyAppoitmentDateModal?.AppointmentDate, enumUtil.enumValidationType.Required, 'Start Date'),
            "PreferredTime": FormValidator(mainRecurringWeeklyModal?.PreferredTime, enumUtil.enumValidationType.Required, 'Preferred Time'),
            "DurationID": FormValidator(mainRecurringWeeklyModal?.DurationID, enumUtil.enumValidationType.Required, 'Duration'),
        }
        setWeeklyValidationModal(validationModal);
        weeklyValModal = validationModal;
    }
    const DateComparisonValidationWeekly = async () => {
        let ValidationModal = {
            ApptDateVal: DateValidator(
                WeeklyAppoitmentDateModal?.AppointmentDate,
                mainRecurringWeeklyModal.EndOn,
                enumUtil.enumValidationType.StartEndDate,
                'Start date should be smaller than end date',
            ),
            // EndDateVal: DateValidator(
            //     mainRecurringWeeklyModal.EndOn,
            //     WeeklyAppoitmentDateModal?.AppointmentDate,
            //     enumUtil.enumValidationType.StartEndDate,
            //     'End date should be greater than start date',
            // ),
        }
        validationModalDateWeekly = ValidationModal
        await setWeeklyDateError(ValidationModal)

    };

    const dailyFormValidation = () => {
        let validationModal = {
            "RepeatAfter": FormValidator(mainRecurringDailyModal?.RepeatAfter, enumUtil.enumValidationType.Required, 'Repeats Every'),
            "EndOn": FormValidator(mainRecurringDailyModal?.EndOn, enumUtil.enumValidationType.Required, 'Ends on'),
            "AppointmentDate": FormValidator(DailyAppoitmentDateModal?.AppointmentDate, enumUtil.enumValidationType.Required, 'Start Date'),
            "PreferredTime": FormValidator(mainRecurringDailyModal?.PreferredTime, enumUtil.enumValidationType.Required, 'Preferred Time'),
            "DurationID": FormValidator(mainRecurringDailyModal?.DurationID, enumUtil.enumValidationType.Required, 'Duration'),
        }
        setDailyValidationModal(validationModal);
        dailyValModal = validationModal;
    }

    const DateComparisonValidationDaily = async () => {
        let ValidationModal = {
            ApptDateVal: DateValidator(
                DailyAppoitmentDateModal?.AppointmentDate,
                mainRecurringDailyModal.EndOn,
                enumUtil.enumValidationType.StartEndDate,
                'Start date should be smaller than end date',
            ),
            // EndDateVal: DateValidator(
            //     mainRecurringDailyModal.EndOn,
            //     DailyAppoitmentDateModal?.AppointmentDate,
            //     enumUtil.enumValidationType.StartEndDate,
            //     'End date should be greater than start date',
            // ),
        }
        validationModalDateDaily = ValidationModal

        setDailyDateError(ValidationModal)


    };

    const FindWeeklyByCriteria = () => {
        DateComparisonValidationWeekly()
        weeklyFormValidation();
        let validation = FormValidator([weeklyValModal], enumUtil.enumValidationType.NullCheck)
        let validationDate = FormValidator([validationModalDateWeekly], enumUtil.enumValidationType.NullCheck)
        let daysValidation = selectedDay?.length > 0

        if (validation) {
            NotificationHandler('Fill all required fields', enumUtil.enumtoaster.error);
            return
        }
        if (validationDate) {
            NotificationHandler('Please enter correct dates', enumUtil.enumtoaster.error);
            return
        }
        if (!daysValidation) {
            NotificationHandler('Please select day(s)', enumUtil.enumtoaster.error);
            return
        }

        let DaysOn = selectedDay?.join(", ")
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.RecurringAppointment,
            "SearchCriteria": { ...saveRecurringWeeklyModal, AppointmentDate: WeeklyAppoitmentDateModal?.AppointmentDate, OnDays: DaysOn }
        }
        setWeeklyData([]);
        setPreviousWeeklyData([]);

        setIsLoading(true);
        ServerRequestProtected(API_URL + '/GetRecurringAppointment', 'post', saveModal).then((response) => {
            let data = [...response]
            data.map((item) => {
                item.DurationID = mainApptModal.DurationID ? mainApptModal.DurationID : item.DurationID
            })

            setWeeklyData(JSON.parse(JSON.stringify(data)));
            setPreviousWeeklyData(JSON.parse(JSON.stringify(data)));
            handleIndexBaseObject(data, weeklyIndexBasedRecord, setWeeklyIndexBasedRecord);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            setWeeklyData([]);
            setPreviousWeeklyData([]);
        })
    }

    const FindDailyByCriteria = () => {

        DateComparisonValidationDaily();
        dailyFormValidation();
        let validation = FormValidator([dailyValModal], enumUtil.enumValidationType.NullCheck);
        let validationDate = FormValidator([validationModalDateDaily], enumUtil.enumValidationType.NullCheck)

        if (validation) {
            NotificationHandler('Fill all required fields', enumUtil.enumtoaster.error);
            return
        }
        if (validationDate) {
            NotificationHandler('Please enter correct dates', enumUtil.enumtoaster.error);
            return
        }
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.RecurringAppointment,
            "SearchCriteria": { ...saveRecurringDailyModal, AppointmentDate: DailyAppoitmentDateModal?.AppointmentDate }
        }

        setDailyData([]);
        setPreviousDailyData([]);
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/GetRecurringAppointment', 'post', saveModal).then((response) => {
            setIsLoading(false);
            let data = [...response]
            data.map((item) => {
                item.DurationID = mainApptModal.DurationID ? mainApptModal.DurationID : item.DurationID
            })
            setDailyData(JSON.parse(JSON.stringify(data)));
            setPreviousDailyData(JSON.parse(JSON.stringify(data)));
            handleIndexBaseObject(data, dailyIndexBasedRecord, setDailyIndexBasedRecord);
        }).catch((error) => {
            setIsLoading(false);
            setDailyData([]);
            setPreviousDailyData([]);
        })
    }

    const handleDailyRecord = (index, type, isTrue, date, recordType) => {
        let modal = { ...dailyIndexBasedRecord }
        let dataModal = [...DailyData]
        let dataPreviousModal = [...previousDailyData]

        if (type === "isEditable") {
            modal[index][type] = isTrue;
        }
        setDailyIndexBasedRecord(modal);
        if (isTrue) {
            getAvailableSlotsIndex(date, index, recordType);
            getProviderScheduler(date, 'Daily', index);
        }
        if (!isTrue) {
            if (dataModal[index]['TimeFrom'] !== dataPreviousModal[index]['TimeFrom']) {

                dataModal[index]['Status'] = 'Available';
                setDailyData(dataModal);

            }

            dataPreviousModal[index] = { ...dataModal[index] };
            setPreviousDailyData(dataPreviousModal);

        }

    }

    const handleDailyPreviousRecord = (index, type, isTrue, date, recordType) => {
        let modal = { ...dailyIndexBasedRecord }

        let dataModal = [...DailyData]
        let dataPreviousData = [...previousDailyData]
        let formatedDate = dataPreviousData?.[index]?.['AppointmentDate']
        if (type === "isEditable") {
            modal[index][type] = isTrue;
        }
        setDailyIndexBasedRecord(modal);

        dataModal[index] = { ...dataPreviousData[index] };

        // getAvailableSlotsIndex(formatedDate, index, 'Daily');
        setDailyData(dataModal)
    }

    const handleWeeklyRecord = (index, type, isTrue, date, recordType) => {
        let modal = { ...weeklyIndexBasedRecord }

        let dataModal = [...WeeklyData]
        let dataPreviousModal = [...previousWeeklyData]

        if (type === "isEditable") {
            modal[index][type] = isTrue;
        }
        setWeeklyIndexBasedRecord(modal);
        if (isTrue) {
            getProviderScheduler(date, 'Weekly', index);
            getAvailableSlotsIndex(date, index, recordType);
        }
        if (!isTrue) {
            if (dataModal[index]['TimeFrom'] !== dataPreviousModal[index]['TimeFrom']) {
                dataModal[index]['Status'] = 'Available';
                setWeeklyData(dataModal);
            }

            dataPreviousModal[index] = { ...dataModal[index] };
            setPreviousWeeklyData(dataPreviousModal)

        }


    }

    const handleWeeklyPreviousRecord = (index, type, isTrue, date, recordType) => {
        let modal = { ...weeklyIndexBasedRecord }

        let dataModal = [...WeeklyData]
        let dataPreviousData = [...previousWeeklyData]
        let formatedDate = dataPreviousData?.[index]?.['AppointmentDate']

        if (type === "isEditable") {
            modal[index][type] = isTrue;
        }
        setWeeklyIndexBasedRecord(modal);

        dataModal[index] = { ...dataPreviousData[index] };

        // getAvailableSlotsIndex(formatedDate, index, 'Weekly');
        setWeeklyData(dataModal);
    }

    const FindByID = () => {
        setIsLoading(true);
        FindDailyByCriteria();
        FindWeeklyByCriteria();
    }

    const getAvailableSlots = (ApptDate, type) => {
        setAvailableSlots([]);
        setDailyAvailableStartTimeSlots([]);
        setIsSlotAvailable(false);
        setWeeklyAvailableStartTimeSlots([]);
        const selectedMainGetter = type === "Daily" ? mainRecurringDailyModal : mainRecurringWeeklyModal;
        const selectedSaveGetter = type === "Daily" ? saveRecurringDailyModal : saveRecurringWeeklyModal;
        const selectedSaveSetter = type === "Daily" ? setSaveRecurringDailyModal : setSaveRecurringWeeklyModal;
        const selectedMainSetter = type === "Daily" ? setMainRecurringDailyModal : setMainRecurringWeeklyModal;

        setIsLoading(true);
        let saveModal = {
            SEARCHCRITERIA: {
                ProviderID: providerID + "",
                LocationID: locationID + "",
                Date: ApptDate,
            },
            TABLENAME: enumUtil.enumAPITableName.Scheduler,
        }

        ServerRequestProtected(API_URL_General + "/AvailableSlots", "POST", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (response) {
                    const AvailableStartTimeSlots = response?.StartTime ? response?.StartTime : [];
                    const AvailableEndTimeSlots = response?.EndTime ? response?.EndTime : [];

                    if (type === "Daily") {
                        setDailyAvailableStartTimeSlots(AvailableStartTimeSlots);
                        setIsSlotAvailable((prev) => ({ ...prev, Daily: true, }));
                    } else if (type === "Weekly") {
                        setWeeklyAvailableStartTimeSlots(AvailableStartTimeSlots);
                        setIsSlotAvailable((prev) => ({ ...prev, Weekly: true }));
                    } else {

                        setDailyAvailableStartTimeSlots(AvailableStartTimeSlots);
                        setWeeklyAvailableStartTimeSlots(AvailableStartTimeSlots);
                        setIsSlotAvailable((prev) => ({ ...prev, Daily: true, Weekly: true }));

                    }
                    setAvailableSlots(response);

                    // setfilteredAvailableSlots(response);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setIsSlotAvailable(false);
                selectedSaveSetter({ ...selectedSaveGetter, PreferredTime: "" });
                selectedMainSetter({ ...selectedMainGetter, PreferredTime: "" });
            })

    }

    const getProviderScheduler = (date, type, index) => {
        let scheduler;

        let postModal = {
            providerID: String(providerID),
            locationID: String(locationID),
            Date: date,
        }
        const provider = postModal["providerID"];

        if (!isNull(providerID) && !isNull(locationID) && !isNull(date)) {
            let modal = { ...(type === 'Daily' ? dailyIndexBasedRecord : weeklyIndexBasedRecord) };
            let dataModal = [...(type === 'Daily' ? DailyData : WeeklyData)]
            const selectedSetter = type === 'Daily' ? setDailyIndexBasedRecord : setWeeklyIndexBasedRecord;
            const selectedDataSetter = type === 'Daily' ? setDailyData : setWeeklyData;

            if (!modal[index]) {
                modal[index] = {
                    isEditable: true,
                    AvailableSlots: [],
                    ProvSchedule: [],
                }
            }

            setIsLoading(true);
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Scheduler,
                SearchCriteria: { ...postModal },
            }
            ServerRequestProtected(API_URL_General + "/ProvidersSchedules", "post", saveModal).then((response) => {
                setIsLoading(false);

                scheduler = response.filter((schedule) => {
                    return (schedule.ProviderID == provider);
                })
                let timeSlot = scheduler?.[0]?.TimeSlot || '30';

                let filteredDuration = DurationDD.filter(item => Number(item.value) >= Number(timeSlot));

                dataModal[index]['DurationID'] = timeSlot;
                modal[index]['ProvSchedule'] = timeSlot;
                modal[index]['DurationDD'] = filteredDuration
                selectedSetter(modal);
                selectedDataSetter(dataModal);

                // handleDuration(modal["providerID"]);
            }).catch((error) => {
                selectedSetter(modal);
                setIsLoading(false);
            })
        }
    }

    const RecurringAppointment = () => {
        return (
            <p className="heading">Recurring Appointment</p>
        )
    }

    const getAvailableSlotsIndex = (date, index, type) => {

        let modal = { ...(type === 'Daily' ? dailyIndexBasedRecord : weeklyIndexBasedRecord) };
        let dataModal = [...(type === 'Daily' ? DailyData : WeeklyData)]
        const selectedSetter = type === 'Daily' ? setDailyIndexBasedRecord : setWeeklyIndexBasedRecord;
        const selectedDataSetter = type === 'Daily' ? setDailyData : setWeeklyData;

        if (!modal[index]) {
            modal[index] = {
                isEditable: true,
                AvailableSlots: []
            }
        }
        modal[index]['AvailableSlots'] = [];

        setIsLoading(true);
        let saveModal = {
            SEARCHCRITERIA: {
                ProviderID: providerID + "",
                LocationID: locationID + "",
                Date: date,
            },
            TABLENAME: enumUtil.enumAPITableName.Scheduler,
        }

        ServerRequestProtected(API_URL_General + "/AvailableSlots", "POST", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (response) {
                    const AvailableStartTimeSlots = response?.StartTime ? response?.StartTime : [];
                    const AvailableEndTimeSlots = response?.EndTime ? response?.EndTime : [];
                    modal[index]['AvailableSlots'] = AvailableStartTimeSlots
                    selectedSetter(modal);
                }
            })
            .catch((error) => {
                let itemFromModal = { ...dataModal?.[index], PreferredTime: "" }
                dataModal[index] = itemFromModal;
                selectedSetter(modal);
                selectedDataSetter(dataModal);
                setIsLoading(false);
                setIsSlotAvailable(false);
            })
    }

    const timeParser = (time, minutes) => {
        // Parse the time string to a Date object
        let formate = checkTimeFormat(time);
        const baseTime = (formate === '12-hour format' && parse(time, 'h:mm a', new Date())) || (formate === '24-hour format' && parse(time, 'HH:mm:ss', new Date()));
        let formattedTime;
        if (minutes) {
            const baseTime = (formate === '12-hour format' && parse(time, 'h:mm a', new Date())) || (formate === '24-hour format' && parse(time, 'HH:mm:ss', new Date()));
            // Add 15 minutes to the base time
            const newTime = addMinutes(baseTime, minutes);
            // Format the result back to a time string
            formattedTime = format(newTime, 'hh:mm a');
        } else {
            formattedTime = format(baseTime, 'hh:mm a');
        }
        return formattedTime
    }


    const handleDateObjForAppt = (time, date) => {

        // // Get system time zone dynamically
        // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Combine into one string
        const dateTimeString = `${date} ${time}`;

        const parsedDate = new Date(dateTimeString)

        return parsedDate;

    }

    const handleStartEndTime = (List) => {

        let formatedList = List?.map((item) => {

            const { TimeFrom, TimeTo, AppointmentDay, Status, TheDate, ...restOfItems } = { ...item }

            let newObject = {
                ...restOfItems,
                "AppointmentTimeFrom": handleDateObjForAppt(item?.TimeFrom, item?.AppointmentDate),
                "AppointmentTimeTo": handleDateObjForAppt(item?.TimeTo, item?.AppointmentDate),
                "AppointmentStart": TimeFrom,
                "AppointmentEnd": TimeTo,
                "DurationID": item?.DurationID + "",
            }

            return newObject;
        })

        return formatedList;
    }

    const handleSaveRecurringAppt = (e) => {

        let selectedDataArray = [...(activeKey === "Week" ? WeeklyData : activeKey === "Day" ? DailyData : [])]
        let formatedDataArray = handleStartEndTime(selectedDataArray);
        const {
            AppointmentDate,
            AppointmentEnd,
            AppointmentEndTime,
            AppointmentStart,
            AppointmentStartTime,
            DurationID,
            ...restOfObj
        } = { ...saveApptModal }
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.RecurringAppointment,
            Data: {
                ...restOfObj,
                AppointmentStatus: 'Scheduled',
                AppointmentStatusID: '1',
            },
            "Main": [...formatedDataArray]
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/SaveRecurringAppointment', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
                NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success);
                let savedDataArray = response?.PatientClaims
                setSavedData(() => (Array.isArray(savedDataArray) ? savedDataArray : []));
                handleSavedDataModal();
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
            })
    }
    const isNonEmptyArray = (data) => Array.isArray(data) && data.length > 0;

    const handleSavedDataModal = () => {
        setIsDataSavedModal(true)
    }
    const onCloseDataModal = () => {
        setIsDataSavedModal(false);
        onCloseSave();
    }

    const handleDeleteDailyRecord = (deleteIndex) => {
        const updatedArray = DailyData.filter((_, i) => i !== deleteIndex);

        //  Rebuild the object with updated keys
        const newObject = {};
        updatedArray.forEach((_, newIndex) => {
            newObject[newIndex] = dailyIndexBasedRecord[newIndex >= deleteIndex ? newIndex + 1 : newIndex];
        });
        setDailyIndexBasedRecord(newObject);
        setDailyData(updatedArray);

    }

    const handleDeleteWeeklyRecord = (deleteIndex) => {
        const updatedArray = WeeklyData.filter((_, i) => i !== deleteIndex);

        //  Rebuild the object with updated keys
        const newObject = {};
        updatedArray.forEach((_, newIndex) => {
            newObject[newIndex] = weeklyIndexBasedRecord[newIndex >= deleteIndex ? newIndex + 1 : newIndex];
        });
        setWeeklyIndexBasedRecord(newObject);

        setWeeklyData(updatedArray);

    }

    let SavedDataModal = ""
    if (isDataSavedModal) {
        SavedDataModal = <DataTable isOpenPopup={isDataSavedModal} onClose={onCloseDataModal} ID={""} saveData={SavedData} />
    }
    useEffect(() => {
        getAvailableSlots(ApptDate, "Both");
    }, [])

    return (
        <Modal show={openPopup} onHide={openPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_export-excel_popup za_recuring-appointment"
        >
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                {SavedDataModal}
                <ModalHeader HeaderName={RecurringAppointment} DeletePopup={''} isClosed={() => onClose()} />
                <div className="col-12">
                    <div className="add_block_appointment w-100">
                        <div className='patient_payment_tabs'>
                            <Tab.Container defaultActiveKey="Day" activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                <div className='ms-0'>
                                    <Nav variant="tabs" className="d-flex border-0 gx-0">
                                        <Nav.Item className="ar-copay-link ar-pad">
                                            <Nav.Link eventKey="Day" className="text">Daily</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad">
                                            <Nav.Link eventKey="Week" className="text">Weekly</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="Day">
                                        <div className="row mt-10">
                                            <div>
                                                <div className="col-md-4">
                                                    <div className={`input ${dailyValidationModal?.RepeatAfter ? 'error' : ''}`}>
                                                        <label>Repeat Every</label>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <input type="text" className="form-control" name="RepeatAfter" id="RepeatAfter" value={mainRecurringDailyModal?.RepeatAfter} onKeyPress={(event) => handleNumericCheck(event, 'decimal')} onChange={HandleOnChangeDaily} />
                                                            <label>Day<span className='req'>*</span></label>
                                                            {dailyValidationModal?.RepeatAfter}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className={`col-md-3 justify-content-end pe-1 input mb-0 ${(dailyValidationModal?.AppointmentDate || DailyDateError?.ApptDateVal) ? 'error' : ''}`}>
                                                    <DatePicker
                                                        label={<span>Start Date<span className='req'>*</span></span>}
                                                        name="StartDate"
                                                        id="StartDate"
                                                        value={DailyAppoitmentDateModal?.AppointmentDate}
                                                        handleCalendarChangefunc={date => handleCalendarChangeAppointmentDaily(date, 'AppointmentDate')}
                                                        isReadOnly={false}
                                                        inputError={(dailyValidationModal?.AppointmentDate || DailyDateError?.ApptDateVal)}
                                                    />
                                                    {dailyValidationModal?.AppointmentDate}
                                                    {DailyDateError?.ApptDateVal}
                                                </div>

                                                <div className={`col-md-3 justify-content-end pe-1 input mb-0 ${(dailyValidationModal?.EndOn || DailyDateError?.ApptDateVal) ? 'error' : ''}`}>
                                                    <DatePicker
                                                        label={<span>Ends on<span className='req'>*</span></span>}
                                                        name="EndOn"
                                                        id="EndOn"
                                                        value={mainRecurringDailyModal?.EndOn}
                                                        handleCalendarChangefunc={date => handleCalendarChangeDaily(date, 'EndOn')}
                                                        isReadOnly={false}
                                                        inputError={(dailyValidationModal?.EndOn || DailyDateError?.ApptDateVal)}
                                                    />
                                                    {dailyValidationModal?.EndOn}
                                                    {DailyDateError?.ApptDateVal}
                                                </div>

                                                <div className="col-md-3 align-content-end px-1">

                                                    <React.Fragment>
                                                        <div className={`input position-relative ${dailyValidationModal?.PreferredTime ? 'error' : ''}`} >
                                                            <label htmlFor="" className={`text ar-light-color ${dailyValidationModal?.PreferredTime ? 'error' : ''}`}>Preferred Time<span className='req'>*</span></label>

                                                            <AvailableSlotsDropdown

                                                                IsSlotAvailable={IsSlotAvailable}
                                                                availableStartTimeSlots={DailyAvailableStartTimeSlots}
                                                                name={'PreferredTime'}
                                                                value={mainRecurringDailyModal?.PreferredTime}
                                                                handleOnChangeStartTime={handleOnChangeDailyStartTime}
                                                                handleOnChange={HandleOnChangeDaily}
                                                                inputError={dailyValidationModal?.PreferredTime}
                                                            />

                                                            {dailyValidationModal?.PreferredTime}
                                                        </div>
                                                    </React.Fragment>
                                                    {/* <SuperSearchList
                                                        type="client"
                                                        id='PreferredTime'
                                                        name='PreferredTime'
                                                        searchValue={mainRecurringDailyModal?.PreferredTime}
                                                        data={AvailableStartTimeSlots}
                                                        onChange={(e) => HandleOnChangeDaily(e)}
                                                        getSelectedData={handleDailySelectedData}
                                                        // is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                        className="form-control rounded"
                                                        inputError={dailyValidationModal?.PreferredTime}
                                                    /> */}

                                                    {dailyValidationModal?.PreferredTime}
                                                </div>

                                                <div className="col-md-3 align-content-end ps-1" >
                                                    <button class="btn btn-orange rounded px-2" onClick={(e) => FindDailyByCriteria(e)}> Check Slots</button>
                                                </div>
                                            </div>


                                        </div>
                                        <div className='Intake_form hk-expand-table px-0'>
                                            {isNonEmptyArray(DailyData) ?
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th className="heading">Date</th>
                                                            <th className="heading">Duration</th>
                                                            <th className="heading">Time</th>
                                                            <th className="heading">Status</th>
                                                            <th className="heading">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {DailyData?.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    {/* {item?.Status === "Unavailable" && dailyIndexBasedRecord?.[index]?.['isEditable'] ? */}
                                                                    {dailyIndexBasedRecord?.[index]?.['isEditable'] ?
                                                                        <React.Fragment>
                                                                            <td >
                                                                                <div>
                                                                                    <DatePicker
                                                                                        // label={<span>Ends on<span className='req'>*</span></span>}
                                                                                        name="EndOn"
                                                                                        id="EndOn"
                                                                                        value={item?.AppointmentDate}
                                                                                        handleCalendarChangefunc={date => handleCalendarChangeDailyIndex(date, 'AppointmentDate', index)}
                                                                                        isReadOnly={false}
                                                                                    />
                                                                                </div>

                                                                            </td>
                                                                            <td >
                                                                                <div className="input">

                                                                                    <SuperSearchList
                                                                                        type="client"
                                                                                        id='DurationID'
                                                                                        name='DurationID'
                                                                                        searchValue={item?.DurationID}
                                                                                        data={dailyIndexBasedRecord?.[index]?.['DurationDD'] ? dailyIndexBasedRecord?.[index]?.['DurationDD'] : []}
                                                                                        onChange={(e) => HandleOnChangeDailyIndex(e, index)}
                                                                                        getSelectedData={(...props) => handleDailySelectedDataIndex(...props, index, item?.TimeFrom)}
                                                                                        // is={is}
                                                                                        icon={'Simple'}
                                                                                        sup_btn='sup_btn'
                                                                                        sup_inp='superSearchVisitInp'
                                                                                        className="form-control rounded"
                                                                                        ScrollOutside={true}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            {/* <td ><p className="text">5:00 PM<i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i></p></td> */}
                                                                            <td>


                                                                                <AvailableSlotsDropdown

                                                                                    IsSlotAvailable={IsSlotAvailable}
                                                                                    availableStartTimeSlots={dailyIndexBasedRecord?.[index]?.['AvailableSlots'] ? dailyIndexBasedRecord?.[index]?.['AvailableSlots'] : []}
                                                                                    name={'TimeFrom'}
                                                                                    value={item?.TimeFrom}
                                                                                    handleOnChangeStartTime={(...params) => handleOnChangeDailyIndexStartTime(...params, index, item?.DurationID)}
                                                                                    handleOnChange={(e) => HandleOnChangeDailyIndex(e, index)}

                                                                                // inputError={dailyValidationModal?.PreferredTime}
                                                                                />

                                                                                {/* <SuperSearchList
                                                                                type="client"
                                                                                id='TimeFrom'
                                                                                name='TimeFrom'
                                                                                searchValue={item?.TimeFrom}
                                                                                data={dailyIndexBasedRecord?.[index]?.['AvailableSlots'] ? dailyIndexBasedRecord?.[index]?.['AvailableSlots'] : []}
                                                                                onChange={(e) => HandleOnChangeDailyIndex(e, index)}
                                                                                getSelectedData={(...props) => handleDailySelectedDataIndex(...props, index)}
                                                                                // is={is}
                                                                                icon={'Simple'}
                                                                                sup_btn='sup_btn'
                                                                                sup_inp='superSearchVisitInp'
                                                                                className="form-control rounded"
                                                                            /> */}
                                                                            </td>
                                                                        </React.Fragment>
                                                                        :
                                                                        <React.Fragment>
                                                                            <td ><p className="text">{item?.AppointmentDate}</p></td>
                                                                            <td ><p className="text">{item?.DurationID}</p></td>
                                                                            <td ><p className="text">{item?.TimeFrom}</p></td>
                                                                        </React.Fragment>
                                                                    }
                                                                    <td ><p className={`${item?.Status == "Unavailable" ? 'Partialdenied' : 'Paid'} ar-status-clm text`}>{item?.Status}</p></td>
                                                                    <td>
                                                                        {/* {item?.Status === "Unavailable" ? dailyIndexBasedRecord?.[index]?.['isEditable'] ? */}
                                                                        {dailyIndexBasedRecord?.[index]?.['isEditable'] ?
                                                                            <div class="d-flex justify-content-center align-items-center gap-1">
                                                                                <i class="icon-check orange-light" onClick={() => handleDailyRecord(index, 'isEditable', false)}></i>
                                                                                <i class="icon-x-cros dark-clr" onClick={() => handleDailyPreviousRecord(index, 'isEditable', false)}></i>
                                                                            </div> :
                                                                            <div className='d-flex justify-content-center align-items-center gap-2' >
                                                                                <i class="icon-Icon-material-edit fs-11 ar-light-color ms-1" onClick={() => handleDailyRecord(index, 'isEditable', true, item?.AppointmentDate, 'Daily')}></i>
                                                                                <i className='icon-delete fs-13 clr-danger' onClick={() => { handleDeleteDailyRecord(index) }}></i>
                                                                            </div>
                                                                        }
                                                                        {/* : <></>} */}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}

                                                        {/* <tr>
                                                        <td >
                                                            <div>
                                                                <DatePicker />
                                                            </div>

                                                        </td>
                                                        <td >
                                                            <div className="input">
                                                                <select className="form-control fc-xs rounded-1" id="DurationID" name="DurationID" value={mainRecurringWeeklyModal?.DurationID} onChange={(e) => HandleOnChangeDaily(e)}>
                                                                    <option className='text fs-12' value={'15'}>15</option>
                                                                    <option className='text fs-12' value={'30'}>30</option>
                                                                    <option className='text fs-12' value={'60'}>60</option>
                                                                </select>

                                                            </div>
                                                        </td>
                                                     <td ><p className="text">5:00 PM<i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i></p></td> 
                                                        <td >
                                                            <CustomTimePicker
                                                                label='Ends Start Time'
                                                            />
                                                        </td>
                                                        <td ><p className="Partialdenied ar-status-clm text">Booked</p></td>
                                                        <td>
                                                            <div class="d-flex justify-content-center align-items-center gap-1">
                                                                <i class="icon-check orange-light"></i>
                                                                <i class="icon-x-cros dark-clr"></i>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td ><p className="text">4/5/2025</p></td>
                                                        <td ><p className="text">30</p></td>
                                                        <td ><p className="text">5:00 PM</p></td>
                                                        <td ><p className="Partialdenied ar-status-clm text">Booked</p></td>
                                                        <td>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i>
                                                            </div>
                                                        </td>
                                                    </tr> */}
                                                    </tbody>
                                                </table> : <React.Fragment></React.Fragment>}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Week">
                                        <div className="row gap-2 mt-10">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className={`input ${weeklyValidationModal?.RepeatAfter ? 'error' : ''}`}>
                                                            <label>Repeat Every</label>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <div className='col-md-3 pe-2'>
                                                                    <input type="text" className="form-control" name="RepeatAfter" id="RepeatAfter" value={mainRecurringWeeklyModal?.RepeatAfter} onKeyPress={(event) => handleNumericCheck(event, 'decimal')} onChange={HandleOnChangeWeekly} />
                                                                </div>

                                                                <label>Weeks<span className='req'>*</span></label>
                                                                {weeklyValidationModal?.RepeatAfter}
                                                                <div className="input">
                                                                    <div className="d-flex custom_check_box justify-content-between gap-2">
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Sunday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Sunday']} id="Sunday" onChange={(e) => handleDaysChange(e, 'Sunday')} />
                                                                            <span className="text ms-1">SU</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Monday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Monday']} id="Monday" onChange={(e) => handleDaysChange(e, 'Monday')} />
                                                                            <span className="text ms-1">MO</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Tuesday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Tuesday']} id="Tuesday" onChange={(e) => handleDaysChange(e, 'Tuesday')} />
                                                                            <span className="text ms-1">TU</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Wednesday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Wednesday']} id="Wednesday" onChange={(e) => handleDaysChange(e, 'Wednesday')} />
                                                                            <span className="text ms-1">WE</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Thursday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Thursday']} id="Thursday" onChange={(e) => handleDaysChange(e, 'Thursday')} />
                                                                            <span className="text ms-1">TH</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Friday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Friday']} id="Friday" onChange={(e) => handleDaysChange(e, 'Friday')} />
                                                                            <span className="text ms-1">FR</span>
                                                                        </div>
                                                                        <div className='d-flex align-items-center'>
                                                                            <input type="checkbox" name="Saturday" className='form-check-input p-0 mt-0' checked={DaysOnObject['Saturday']} id="Saturday" onChange={(e) => handleDaysChange(e, 'Saturday')} />
                                                                            <span className="text ms-1">SA</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className='row '>
                                                    <div className={`col-md-3 justify-content-end pe-1 input mb-0 ${(weeklyValidationModal?.AppointmentDate || WeeklyDateError?.ApptDateVal) ? 'error' : ''}`}>
                                                        <DatePicker
                                                            label={<span>Start Date<span className='req'>*</span></span>}
                                                            name="StartDate"
                                                            id="StartDate"
                                                            value={WeeklyAppoitmentDateModal?.AppointmentDate}
                                                            handleCalendarChangefunc={date => handleCalendarChangeAppointmentWeekly(date, 'AppointmentDate')}
                                                            isReadOnly={false}
                                                            inputError={(weeklyValidationModal?.AppointmentDate || WeeklyDateError?.ApptDateVal)}
                                                        />
                                                        {weeklyValidationModal?.AppointmentDate}
                                                        {WeeklyDateError?.ApptDateVal}
                                                    </div>

                                                    <div className={`col-md-3 justify-content-end input mb-0  pe-1 ${(weeklyValidationModal?.EndOn || WeeklyDateError?.ApptDateVal) ? 'error' : ''}`}>

                                                        <DatePicker
                                                            label={<span>Ends on<span className='req'>*</span></span>}
                                                            name="EndOn"
                                                            id="EndOn"
                                                            value={mainRecurringWeeklyModal?.EndOn}
                                                            handleCalendarChangefunc={date => handleCalendarChangeWeekly(date, 'EndOn')}
                                                            isReadOnly={false}
                                                            inputError={(weeklyValidationModal?.EndOn || WeeklyDateError?.ApptDateVal)}
                                                        />
                                                        {weeklyValidationModal?.EndOn}
                                                        {WeeklyDateError?.ApptDateVal}
                                                    </div>

                                                    {/* <div className="col-md-3 px-1">
                                                        <label htmlFor="" className='text ar-light-color'>Duration<span className='req'>*</span></label>
                                                        <div className={`input ${weeklyValidationModal?.DurationID ? 'error' : ''}`}>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='DurationID'
                                                                name='DurationID'
                                                                searchValue={mainRecurringWeeklyModal.DurationID}
                                                                data={DurationDD}
                                                                onChange={(e) => HandleOnChangeWeekly(e)}
                                                                getSelectedData={handleWeeklySelectedData}
                                                                // is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={weeklyValidationModal?.DurationID}
                                                            />
                                                            {weeklyValidationModal?.DurationID}
                                                        </div>
                                                    </div> */}

                                                    <div className="col-md-3 align-content-end px-1">
                                                        {/* <label htmlFor="" className={`text ar-light-color ${weeklyValidationModal?.PreferredTime ? 'error' : ''}`}>Preferred Time<span className='req'>*</span></label> */}
                                                        <React.Fragment>
                                                            <div className={`input position-relative ${dailyValidationModal?.PreferredTime ? 'error' : ''}`} >
                                                                <label htmlFor="" className={`text ar-light-color ${weeklyValidationModal?.PreferredTime ? 'error' : ''}`}>Preferred Time<span className='req'>*</span></label>
                                                                {/* <label>Start Time<span style={{ color: 'red' }}>*</span></label> */}
                                                                {/* <CustomUseRef onClose={closeDropdown} IsActivePtPayments={filterstatus}> */}
                                                                <AvailableSlotsDropdown

                                                                    IsSlotAvailable={IsSlotAvailable}
                                                                    availableStartTimeSlots={WeeklyAvailableStartTimeSlots}
                                                                    name={'PreferredTime'}
                                                                    value={mainRecurringWeeklyModal?.PreferredTime}
                                                                    handleOnChangeStartTime={handleOnChangeWeeklyStartTime}
                                                                    handleOnChange={HandleOnChangeWeekly}
                                                                    inputError={weeklyValidationModal?.PreferredTime}
                                                                />
                                                                {/* </CustomUseRef> */}
                                                                {dailyValidationModal?.PreferredTime}
                                                            </div>
                                                        </React.Fragment>
                                                        {/* <SuperSearchList
                                                            type="client"
                                                            id='PreferredTime'
                                                            name='PreferredTime'
                                                            searchValue={mainRecurringWeeklyModal?.PreferredTime}
                                                            data={AvailableStartTimeSlots}
                                                            onChange={(e) => HandleOnChangeWeekly(e)}
                                                            getSelectedData={handleWeeklySelectedData}
                                                            // is={is}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                            inputError={weeklyValidationModal?.PreferredTime}
                                                        /> */}
                                                        {weeklyValidationModal?.PreferredTime}
                                                    </div>

                                                    <div className="col-md-3 align-content-end ps-1" >
                                                        <button class="btn btn-orange rounded px-2" onClick={(e) => FindWeeklyByCriteria(e)}> Check Slots</button>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>

                                        <div className='Intake_form hk-expand-table px-0'>
                                            {isNonEmptyArray(WeeklyData) ?
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th className="heading">Date</th>
                                                            <th className="heading">Duration</th>
                                                            <th className="heading">Time</th>
                                                            <th className="heading">Status</th>
                                                            <th className="heading">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {WeeklyData?.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    {/* {item.Status === "Unavailable" && weeklyIndexBasedRecord?.[index]?.['isEditable']  */}
                                                                    {weeklyIndexBasedRecord?.[index]?.['isEditable'] ?
                                                                        <React.Fragment>
                                                                            <td >
                                                                                <div>
                                                                                    <DatePicker
                                                                                        // label={<span>Ends on<span className='req'>*</span></span>}
                                                                                        name="AppointmentDate"
                                                                                        id="AppointmentDate"
                                                                                        value={item?.AppointmentDate}
                                                                                        handleCalendarChangefunc={date => handleCalendarChangeWeeklyIndex(date, 'AppointmentDate', index)}
                                                                                        isReadOnly={false}
                                                                                    />
                                                                                </div>

                                                                            </td>
                                                                            <td >
                                                                                <div className="input">

                                                                                    <SuperSearchList
                                                                                        type="client"
                                                                                        id='DurationID'
                                                                                        name='DurationID'
                                                                                        searchValue={item?.DurationID}
                                                                                        data={weeklyIndexBasedRecord?.[index]?.['DurationDD'] ? weeklyIndexBasedRecord?.[index]?.['DurationDD'] : []}
                                                                                        onChange={(e) => HandleOnChangeWeeklyIndex(e, index)}
                                                                                        getSelectedData={(...params) => handleWeeklySelectedDataIndex(...params, index, item?.TimeFrom)}
                                                                                        // is={is}
                                                                                        icon={'Simple'}
                                                                                        sup_btn='sup_btn'
                                                                                        sup_inp='superSearchVisitInp'
                                                                                        className="form-control rounded"

                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            {/* <td ><p className="text">5:00 PM<i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i></p></td> */}
                                                                            <td>

                                                                                <AvailableSlotsDropdown

                                                                                    IsSlotAvailable={IsSlotAvailable}
                                                                                    availableStartTimeSlots={weeklyIndexBasedRecord?.[index]?.['AvailableSlots'] ? weeklyIndexBasedRecord?.[index]?.['AvailableSlots'] : []}
                                                                                    name={'TimeFrom'}
                                                                                    value={item?.TimeFrom}
                                                                                    handleOnChangeStartTime={(...params) => handleOnChangeWeeklyIndexStartTime(...params, index, item?.DurationID)}
                                                                                    handleOnChange={(e) => HandleOnChangeWeeklyIndex(e, index)}

                                                                                // inputError={dailyValidationModal?.PreferredTime}
                                                                                />

                                                                                {/* <SuperSearchList
                                                                            type="client"
                                                                            id='TimeFrom'
                                                                            name='TimeFrom'
                                                                            searchValue={item?.TimeFrom}
                                                                            data={weeklyIndexBasedRecord?.[index]?.['AvailableSlots'] ? weeklyIndexBasedRecord?.[index]?.['AvailableSlots'] : []}
                                                                            onChange={(e) => HandleOnChangeWeeklyIndex(e, index)}
                                                                            getSelectedData={(...params) => handleWeeklySelectedDataIndex(...params, index)}
                                                                            // is={is}
                                                                            icon={'Simple'}
                                                                            sup_btn='sup_btn'
                                                                            sup_inp='superSearchVisitInp'
                                                                            className="form-control rounded"
                                                                        /> */}
                                                                            </td>
                                                                        </React.Fragment> :
                                                                        <React.Fragment>
                                                                            <td ><p className="text">{item?.AppointmentDate}</p></td>
                                                                            <td ><p className="text">{item?.DurationID}</p></td>
                                                                            <td ><p className="text">{item?.TimeFrom}</p></td>
                                                                        </React.Fragment>}
                                                                    <td ><p className={`${item.Status === "Unavailable" ? 'Partialdenied' : 'Paid'} ar-status-clm text`}>{item?.Status}</p></td>
                                                                    <td>
                                                                        {/* {item.Status === "Unavailable" ? weeklyIndexBasedRecord?.[index]?.['isEditable'] ? */}
                                                                        {weeklyIndexBasedRecord?.[index]?.['isEditable'] ?
                                                                            <div class="d-flex justify-content-center align-items-center gap-1">
                                                                                <i class="icon-check orange-light" onClick={() => handleWeeklyRecord(index, 'isEditable', false)}></i>
                                                                                <i class="icon-x-cros dark-clr" onClick={() => handleWeeklyPreviousRecord(index, 'isEditable', false)}></i>
                                                                            </div> :
                                                                            <div className='d-flex justify-content-center align-items-center gap-2' >
                                                                                <i class="icon-Icon-material-edit fs-11 ar-light-color ms-1" onClick={() => handleWeeklyRecord(index, 'isEditable', true, item?.AppointmentDate, 'Weekly')}></i>
                                                                                <i className='icon-delete fs-13 clr-danger' onClick={() => { handleDeleteWeeklyRecord(index) }}></i>
                                                                            </div>
                                                                            // : <></>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        {/* <tr>
                                                        <td >
                                                            <div>
                                                                <DatePicker />
                                                            </div>

                                                        </td>
                                                        <td >
                                                            <div className="input">
                                                                <select className="form-control fc-xs rounded-1" id="PaginationDefaultRows" name="RowsPerPage">
                                                                    <option className='text fs-12'>30</option>
                                                                </select>
                                                            </div>
                                                        </td>
                                                         <td ><p className="text">5:00 PM<i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i></p></td>
                                                        <td >
                                                            <CustomTimePicker
                                                                label='Ends Start Time'
                                                            />
                                                        </td>
                                                        <td ><p className="Partialdenied ar-status-clm text">Booked</p></td>
                                                        <td>
                                                            <div class="d-flex justify-content-center align-items-center gap-1">
                                                                <i class="icon-check orange-light"></i>
                                                                <i class="icon-x-cros dark-clr"></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td ><p className="text">4/5/2025</p></td>
                                                        <td ><p className="text">30</p></td>
                                                        <td ><p className="text">5:00 PM</p></td>
                                                        <td ><p className="Partialdenied ar-status-clm text">Booked</p></td>
                                                        <td>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <i class="icon-Icon-material-edit fs-11 ar-light-color ms-1"></i>
                                                            </div>
                                                        </td>
                                                    </tr> */}
                                                    </tbody>
                                                </table> : <React.Fragment></React.Fragment>}
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => onClose()}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={(e) => handleSaveRecurringAppt(e)}>Save</button>
            </div>
        </Modal>
    )
}

export default RecurringPopup
